import React from 'react'
import config from 'constants/config'
import SearchHeader from 'components/Search/SearchHeader/SearchHeader'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'

function HotelSearchFullScreenPage() {
  return (
    <>
      <SearchHeader title={config.searchFormSection.title} />
      <ErrorBoundary fallback={null}>
        <PromptCardSelector tripReengagement />
      </ErrorBoundary>
    </>
  )
}

export default HotelSearchFullScreenPage
